<template>
  <div>
    <div class="up-input-group">
      <div>
        <up-select
          size="sm"
          labelIcon="mdi mdi-alpha-t-box-outline"
          label="Type"
          v-model="thermometer.type"
        >
          <option value="C">Celsius</option>
          <option value="F">fahrenheit</option>
        </up-select>
      </div>
      <div>
        <up-numberinput
          size="xs"
          v-model="thermometer.start"
          labelIcon="mdi mdi-alpha-s-box-outline"
          label="Start"
        ></up-numberinput>
      </div>
      <div>
        <up-numberinput
          size="xs"
          v-model="thermometer.end"
          labelIcon="mdi mdi-alpha-e-box-outline"
          label="End"
        ></up-numberinput>
      </div>
      <div>
        <up-numberinput
          size="xs"
          v-model="thermometer.stepsize"
          labelIcon="mdi mdi-alpha-s-box-outline"
          label="Stepsize"
        ></up-numberinput>
      </div>
      <div>
        <up-numberinput
          size="xs"
          v-model="thermometer.fill_upto"
          labelIcon="mdi mdi-alpha-f-box-outline"
          label="Fill Upto"
        ></up-numberinput>
      </div>
      <div>
        <up-numberinput
          size="xs"
          v-model="thermometer.num_lines"
          labelIcon="mdi mdi-alpha-l-box-outline"
          label="No. of Lines"
        ></up-numberinput>
      </div>
      <div>
        <up-select
          size="sm"
          v-model="thermometer.design_type"
          label="Designs"
          labelIcon="mdi mdi-alpha-d-box-outline"
        >
          <option value="D1">Design 1</option>
          <option value="D2">Design 2</option>
          <option value="D3">Design 3</option>
        </up-select>
      </div>
    </div>
    <div class="columns is-multiline">
      <div class="column is-6">
        <style-editor
          v-model="thermometer.styles"
          show_bg_color
          show_border_color
        ></style-editor>
      </div>
      <div v-if="thermometer.design_type == 'D3'" class="column is-6">
        <style-editor
          v-model="thermometer.box_styles"
          show_bg_color
          title="Box"
        ></style-editor>
      </div>
      <div class="column is-12">
        <show-thermometer :thermometer="thermometer"></show-thermometer>
      </div>
    </div>
  </div>
</template>

<script>
import ShowThermometer from "./ShowThermometer.vue";
import { defaultThermometerValue } from "./utils";
import StyleEditor from "@/components/Common/StyleEditor/StyleEditor.vue";

import UpNumberinput from "@/components/UI/Inputs/UpNumberinput";
import UpSelect from "@/components/UI/Inputs/UpSelect";
export default {
  name: "set-thermometer",
  components: {
    ShowThermometer,
    StyleEditor,
    UpNumberinput,
    UpSelect,
  },
  props: {
    value: {
      type: Object,
    },
  },
  data() {
    return {
      thermometer: this.value ? this.value : defaultThermometerValue(),
    };
  },
  watch: {
    value: {
      handler: function(new_value) {
        this.thermometer = new_value;
      },
      deep: true,
    },
    thermometer: {
      handler: function(new_value) {
        this.$emit("input", new_value);
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
